import React, {useContext, useEffect, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import parse from "html-react-parser";
import SignPadForEsigns from "../CommonComponents/SignPadForEsigns";
import {Modal} from "react-bootstrap";

export default () => {//show additional terms data of the Invoice 2
    let PageView = useContext(ViewMangementContext)
    let [EsignForCharges , setEsignForCharges ] = useState('')
    const OpenSignaturePad = (For) => {
        Record.setESignModal(true)
        setEsignForCharges(For)
    }

    useEffect(() => {//open signature pad for esign's.
        let element = document.getElementsByClassName('esign')
        for (let i = 1; i < element.length; i++) {
            if (element[i] != null) {
                element[i].addEventListener('click', function (evt) {
                    let target = evt.target.id;
                    OpenSignaturePad(target);
                })
            }
        }
    },[])

    let Record = useContext(RecordsManagementContext)
    let IV2_PageDetails = Record.IV2_PageDetails
    const handleModal = () => {//used to close the modal
        Record.setESignModal(false)
    }
    if (IV2_PageDetails.MaxPrice && IV2_PageDetails.MaxPrice.Show) {
        return (
            <>
            <div className='card mt-2'>
                <div className='card-header bg-secondary'>{IV2_PageDetails.MaxPrice.Title}</div>
                <div className='card-body p-0 small'>
                    {parse(`${IV2_PageDetails.MaxPrice.Content}`)}
                </div>
            </div>
                <Modal show={Record.ESignModal} onHide={()=>handleModal()} className={
                    'sign_estimate_modal'}
                       style={{top: "16%"}}
                >
                    <Modal.Header ><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                        Signature Pad </h5>
                        <button onClick={handleModal}
                                style={{color: "red",background: "white",border: "white" , height: "5%"}}>
                            <b className = "contactInfoCloseBtn" >X</b></button></Modal.Header>
                    <Modal.Body> <SignPadForEsigns For={EsignForCharges}/></Modal.Body>
                </Modal>

    </>

        )
    } else {
        return (<></>);
    }
}